import { useState } from "react";
import { Button, Dialog, TextField, Typography } from "@/components/kit";
import { IUserResponse } from "../types";
import { useNavigate } from "react-router-dom";

const RevokeUserDialog = ({
  selectedUser,
  setSelectedUser,
  onRevokeUser,
  isRevokingUser,
}: {
  selectedUser: IUserResponse | null;
  setSelectedUser: (user: IUserResponse | null) => void;
  onRevokeUser: (id: string, callback?: () => void) => void;
  isRevokingUser: boolean;
}) => {
  const [inputText, setInputText] = useState("");
  const navigate = useNavigate();
  return (
    <Dialog
      open={!!selectedUser}
      handler={() => {
        setSelectedUser(null);
        setInputText("");
      }}
      title="Delete MSP admin?"
    >
      <div className="flex flex-col gap-4 mt-4">
        <Typography variant="Body1-Regular">
          Are you sure you want to delete this MSP admin? This action is
          irreversible and cannot be undone.
        </Typography>
        <Typography variant="Body1-Regular">
          To confirm, please type{" "}
          <span className="font-bold">&apos;Delete&apos;</span> in the box
          below{" "}
        </Typography>
        <TextField
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Write “Delete” here"
          initialFocus={true}
        />
      </div>
      <div className="flex justify-end gap-3 mt-4">
        <Button
          variant="outlined"
          color="red"
          onClick={() => setSelectedUser(null)}
        >
          Cancel
        </Button>
        <Button
          variant="gradient"
          onClick={() =>
            onRevokeUser(selectedUser?.id ?? "", () => {
              setSelectedUser(null);
              setInputText("");
              navigate("/admins");
            })
          }
          disabled={inputText !== "Delete" || isRevokingUser}
          isLoading={isRevokingUser}
        >
          Delete
        </Button>
      </div>
    </Dialog>
  );
};

export default RevokeUserDialog;
